const PrivacyPolicy = () => (
  <div style={{ padding: '2rem', lineHeight: 1.6 }}>
    <h1>プライバシーポリシー</h1>
    <p>最終更新日: 2025年11月7日</p>
    <p>
      当社は、ユーザーの個人情報を適切に取り扱うことを重要な責務と考えています。
      本ポリシーでは、収集する情報の種類、利用目的、および保護方法について説明します。
    </p>
    <p>Test</p>
  </div>
);

export default PrivacyPolicy;
